import React, { useEffect, useState, useRef, useMemo } from 'react';
import { ChevronDown, ChevronUp, Download, Eye, EyeOff, X, Search, ChevronRight, Check, ArrowLeft } from 'lucide-react';
import uploading from './../assets/uploading.png';
import download from './../assets/downloading.png';
import downloadingRed from './../assets/downloadingRed.png';
import calendar from './../assets/calendar.png';
import './Commponentmodal.css';
import { getVehicleClassData } from '../Utils/helper';
import DatePicker from 'react-datepicker';
import { ErrorToast, SuccessToast } from '../Utils/toast';
import { API } from '../Common/Api';
import moment from 'moment';
import { Button } from '../Common/Button';
import CommonTable from '../Common/CommonTable';
import { vehicleClasses } from '../Utils/Constants';
import CustomSelectInput from './SelectInput';
import { useDispatch, useSelector } from 'react-redux';
import { ACTIONS } from '../redux/actions';
import TextInput from './TextInput';


// Fetch the full matching inventory in one request so we can group + paginate by batch on the client
const FETCH_ALL_LIMIT = 100000;

// Colored status pill — green for Assigned, red for Unassigned
const StatusBadge = ({ status }) => {
  const base = "inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium";
  if (status === "Assigned")
    return <span className={`${base} bg-green-100 text-green-800`}><span className="h-2 w-2 bg-green-500 rounded-full" />Assigned</span>;
  if (status === "Unassigned")
    return <span className={`${base} bg-red-100 text-red-700`}><span className="h-2 w-2 bg-red-500 rounded-full" />Unassigned</span>;
  return <span className={`${base} bg-gray-100 text-gray-700`}>{status || 'N/A'}</span>;
};

// Custom-styled checkbox using the brand red accent (replaces default blue checkbox)
const CustomCheckbox = ({ checked = false, indeterminate = false, onChange, disabled = false, className = '', onClick }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) ref.current.indeterminate = !!indeterminate && !checked;
  }, [indeterminate, checked]);

  return (
    <label
      className={`ct-checkbox ${disabled ? 'ct-checkbox--disabled' : ''} ${className}`}
      onClick={onClick}
    >
      <input
        ref={ref}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <span className="ct-checkbox__box">
        <Check className="ct-checkbox__tick" strokeWidth={3} />
      </span>
    </label>
  );
};

const CommonTableModal = ({ open, onClose, title, agentName, agentId, requestId, maxQuantity, reqVehicleClass, showSearch, sampleFileType }) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [tableData1, setTableData1] = useState([]);
  const [vcClass, setVcClass] = useState(reqVehicleClass || '');
  const [sortedIndex, setSortedIndex] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc');
  const [activeTab, setActiveTab] = useState('available');
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [assignCount, setAssignCount] = useState(0);
  const [selectedClass, setSelectedClass] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [visibleRows, setVisibleRows] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pagination, setPagination] = useState(null);
  const [pagination1, setPagination1] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadCheckFlag, setUploadCheckFlag] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [chips, setChips] = useState([]);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    setSearchQuery(chips.join(','));
    setCurrentPage(1);
  }, [chips, setSearchQuery]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (value.includes(',') || value.includes(' ') || value.includes('\n')) {
      const tokens = value.split(/[\s,]+/).map(t => t.trim()).filter(Boolean);
      if (tokens.length > 0) {
        setChips(prev => {
          const uniqueTokens = tokens.filter(t => !prev.includes(t));
          return [...prev, ...uniqueTokens];
        });
        setInputValue('');
      }
    } else {
      setInputValue(value);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',' || e.key === ' ') {
      e.preventDefault();
      const value = inputValue.trim().replace(/,$/, '');
      if (value) {
        const tokens = value.split(/[\s,]+/).map(t => t.trim()).filter(Boolean);
        setChips(prev => {
          const uniqueTokens = tokens.filter(t => !prev.includes(t));
          return [...prev, ...uniqueTokens];
        });
      }
      setInputValue('');
    } else if (e.key === 'Backspace' && !inputValue) {
      setChips(prev => prev.slice(0, -1));
    }
  };

  const handleInputBlur = () => {
    const value = inputValue.trim();
    if (value) {
      const tokens = value.split(/[\s,]+/).map(t => t.trim()).filter(Boolean);
      setChips(prev => {
        const uniqueTokens = tokens.filter(t => !prev.includes(t));
        return [...prev, ...uniqueTokens];
      });
      setInputValue('');
    }
  };

  const removeChip = (indexToRemove) => {
    setChips(prev => prev.filter((_, idx) => idx !== indexToRemove));
  };

  const selectedItemsMap = useRef({});

  // Redux setup
  const dispatch = useDispatch();
  const assignAgentExcelState = useSelector(state => state.AssignAgentExcel || {});

  const getData = async () => {
    // Search is applied client-side (by whole batch), so we always pull the full VC dataset here
    const data = {
      page: 1,
      limit: FETCH_ALL_LIMIT,
      search: "",
      startDate: "",
      endDate: "",
      status: "Unassigned",
      // Activated FASTags cannot be moved, so they must never appear in the
      // assignable "Available FASTag" pool.
      isActivated: "false",
      VC: vcClass || ""
    };

    const response = await API.GetInventoryDistributor(data);

    if (response.status === 200 && response.success) {
      // SuccessToast(response.message);
      setTableData(response.data?.data || []);
      setPagination(response.data?.pagination);

    } else {
      ErrorToast(response.message);
    }

  }

  const getData1 = async () => {

    const data = {
      page: 1,
      limit: FETCH_ALL_LIMIT,
      search: "",
      startDate: "",
      endDate: "",
      status: "Assigned",
      agent: agentId
    };

    const response = await API.GetInventoryDistributor(data);

    if (response.status === 200 && response.success) {
      // SuccessToast(response.message);
      setTableData1(response.data?.data);
      setPagination1(response.data?.pagination);

    } else {
      ErrorToast(response.message);
    }

  }


  // Reset VC filter to requested vehicle class when modal opens with a new request
  useEffect(() => {
    if (open) {
      setVcClass(reqVehicleClass || '');
      setChips([]);
      setInputValue('');
      setCurrentPage(1);
    }
  }, [open, reqVehicleClass]);

  // Fetch the full dataset when the VC filter / tab changes (search & pagination are client-side)
  useEffect(() => {
    getData();
    getData1();
  }, [activeTab, vcClass]);

  // Reset to the first page whenever the filters, search, tab, or page size change
  useEffect(() => {
    setCurrentPage(1);
  }, [activeTab, vcClass, chips, inputValue, itemsPerPage]);

  // Effect to handle Redux state changes for file upload
  useEffect(() => {
    if (uploadCheckFlag) {
      setIsUploading(assignAgentExcelState.AssignAgentExcelLoading);

      if (!assignAgentExcelState.AssignAgentExcelLoading) {
        if (assignAgentExcelState.AssignAgentExcelData) {
          SuccessToast('File uploaded and FASTags assigned successfully!');
          setSelectedFile(null);
          setActiveTab('assigned'); // Switch to assigned tab
          getData();
          getData1();
          // Reset upload flag
          setUploadCheckFlag(false);
          // ✅ Dispatch global refresh
          dispatch({ type: "REFRESH_DATA" });
          // Close modal and refresh parent data
          onClose();
        } else if (assignAgentExcelState.AssignAgentExcelError) {
          ErrorToast(assignAgentExcelState.AssignAgentExcelError || 'Failed to upload file');
          setUploadCheckFlag(false);
        }
      }
    }
  }, [assignAgentExcelState, uploadCheckFlag]);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [open]);

  const handleAssignNow = () => {
    // Do API call here if needed
    assignNow();
  };

  const toggleVisibility = (index, row) => {
    const isVisible = visibleRows[index];
    const newVisibility = { ...visibleRows, [index]: !isVisible };
    setVisibleRows(newVisibility);

    if (window.innerWidth >= 0) {
      setModalOpen(!isVisible);
    }

    if (!isVisible) {
      setSelectedClass(row);
      setSelectedIndex(index);
    }
  };

  const vehicleData = getVehicleClassData(selectedClass?.vehicleClass);

  /* ---------- sorting ---------- */
  const getSortedData = (col) => {
    if (sortedIndex === null) return activeTab === 'available' ? tableData : tableData1;

    const { accessor } = col[sortedIndex];

    return [...tableData].sort((a, b) => {
      const valA = a[accessor];
      const valB = b[accessor];

      // if the column is a date, compare as Date objects
      const isDateCol = accessor.toLowerCase().includes('date');
      const A = isDateCol ? new Date(valA) : valA;
      const B = isDateCol ? new Date(valB) : valB;

      if (A < B) return sortDirection === 'asc' ? -1 : 1;
      if (A > B) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
  };

  const fileInputRef = useRef(null);

  const handleBoxClick = () => {
    fileInputRef.current.click(); // Trigger file input click
  };

  // File validation function
  const validateFile = (file) => {
    const allowedTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel',
      '.xlsx',
      '.xls'
    ];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!allowedTypes.some(type =>
      file.type === type || file.name.toLowerCase().endsWith(type)
    )) {
      ErrorToast('Please select a valid Excel file (.xlsx or .xls)');
      return false;
    }

    if (file.size > maxSize) {
      ErrorToast('File size should not exceed 5MB');
      return false;
    }

    return true;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && validateFile(file)) {
      setSelectedFile(file);
    } else {
      // Clear the input if validation fails
      e.target.value = '';
    }
  };

  // Handle file upload
  const handleFileUpload = () => {
    if (!selectedFile) {
      ErrorToast('Please select a file first');
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('agentId', agentId);
    if (requestId) {
      formData.append('requestId', requestId);
    }

    // Dealer assignment uses a dedicated re-homing endpoint (distributor -> dealer).
    // Handled directly (not via the agent Redux flow) to keep the two paths isolated.
    if (sampleFileType === 'dealerAssignment') {
      setIsUploading(true);
      API.AssignDealerExcel(formData)
        .then((res) => {
          if (res?.status === 200 && res?.success) {
            SuccessToast(res?.message || 'File uploaded and FASTags assigned to dealer successfully!');
            setSelectedFile(null);
            setActiveTab('assigned');
            getData();
            getData1();
            dispatch({ type: 'REFRESH_DATA' });
            onClose();
          } else {
            ErrorToast(res?.message || res?.error || 'Failed to upload file');
          }
        })
        .catch(() => ErrorToast('Failed to upload file'))
        .finally(() => setIsUploading(false));
      return;
    }

    // Default: distributor/dealer -> agent Excel assignment (existing Redux flow).
    dispatch(ACTIONS.AssignAgentExcelAction(formData));
    setUploadCheckFlag(true);
  };

  const handleDownloadSample = async (e) => {
    e.preventDefault();

    // Check if we need to download a specific static file
    if (sampleFileType === 'dealerAssignment') {
      const link = document.createElement('a');
      link.href = '/samples/Assigned%20inventory%20to%20Dealer.xlsx';
      link.download = 'Assigned inventory to Dealer.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      SuccessToast('Sample file downloaded successfully!');
      return;
    }
    if (sampleFileType === 'agentAssignment') {
      const link = document.createElement('a');
      link.href = '/samples/Assigned%20inventory%20to%20Agent.xlsx';
      link.download = 'Assigned inventory to Agent.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      SuccessToast('Sample file downloaded successfully!');
      return;
    }

    // Default behavior: fetch from API
    try {
      const params = {
        agentId: agentId
      };

      const blob = await API.GetDistributeExcelInventory(params);

      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'sample_distribute_inventory.xlsx'; // You can customize the filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      SuccessToast('Sample file downloaded successfully!');
    } catch (error) {
      console.error('Download failed:', error);
      ErrorToast('Failed to download sample file. Please try again.');
    }
  };

  // Show each FASTag as its own row (no Batch ID grouping). The rest of the
  // selection / search / pagination logic works on these single-item "groups".
  const groupByBatch = (rows) => (rows || []).map((item) => ({
    batchId: item.batchId || 'N/A',
    tagRefId: item.tagRefId,
    items: [item],
    sample: item,
  }));

  const groupedAvailable = useMemo(() => groupByBatch(tableData), [tableData]);
  const groupedAssigned = useMemo(() => groupByBatch(tableData1), [tableData1]);

  // Search tokens (committed chips + the value being typed)
  const searchTokens = useMemo(() => {
    const toks = [...chips];
    if (inputValue.trim()) toks.push(inputValue.trim());
    return toks.map((t) => t.toLowerCase());
  }, [chips, inputValue]);

  // A batch matches if ANY of its tags matches ANY token (by tag ref / serial / batch id).
  // Matching keeps the WHOLE batch so selection stays in full bunches.
  const filteredAvailable = useMemo(() => {
    if (searchTokens.length === 0) return groupedAvailable;
    return groupedAvailable.filter((g) =>
      g.items.some((item) =>
        searchTokens.some((tok) =>
          (item.tagRefId || '').toLowerCase().includes(tok) ||
          (item.serialNumber || '').toLowerCase().includes(tok) ||
          (item.batchId || '').toLowerCase().includes(tok)
        )
      )
    );
  }, [groupedAvailable, searchTokens]);

  // Client-side pagination over batches
  const paginatedAvailable = useMemo(
    () => filteredAvailable.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage),
    [filteredAvailable, currentPage, itemsPerPage]
  );
  const paginatedAssigned = useMemo(
    () => groupedAssigned.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage),
    [groupedAssigned, currentPage, itemsPerPage]
  );

  // Tags shown on the current available page (used for the "select all" header checkbox)
  const currentPageItems = useMemo(
    () => paginatedAvailable.flatMap((g) => g.items),
    [paginatedAvailable]
  );
  const isAllSelected = currentPageItems.length > 0 && currentPageItems.every((it) => selectedRows.includes(it._id));

  // Add ids to the selection while respecting the maxQuantity limit
  const addIdsRespectingLimit = (idsToAdd, sourceItems) => {
    const limit = parseInt(maxQuantity, 10);
    setSelectedRows((prev) => {
      const prevSet = new Set(prev);
      const newIds = idsToAdd.filter((id) => !prevSet.has(id));
      if (newIds.length === 0) return prev;

      let toAdd = newIds;
      if (!isNaN(limit) && limit > 0 && prevSet.size + newIds.length > limit) {
        const availableSpace = limit - prevSet.size;
        if (availableSpace <= 0) {
          ErrorToast(`Maximum limit of ${limit} items already reached.`);
          return prev;
        }
        toAdd = newIds.slice(0, availableSpace);
        ErrorToast(`Added only ${toAdd.length} items to reach the limit of ${limit}.`);
      }

      const toAddSet = new Set(toAdd);
      sourceItems.forEach((it) => {
        if (toAddSet.has(it._id)) selectedItemsMap.current[it._id] = it.vehicleClass;
      });
      return [...prev, ...toAdd];
    });
  };

  const removeIds = (idsToRemove) => {
    const removeSet = new Set(idsToRemove);
    setSelectedRows((prev) => prev.filter((id) => !removeSet.has(id)));
  };

  // Selection state of a batch row: 'all' | 'some' | 'none'
  const getBatchSelectionState = (group) => {
    const ids = group.items.map((i) => i._id);
    const selectedCount = ids.filter((id) => selectedRows.includes(id)).length;
    if (selectedCount === 0) return 'none';
    if (selectedCount === ids.length) return 'all';
    return 'some';
  };

  const toggleBatchSelection = (group, checked) => {
    const ids = group.items.map((i) => i._id);
    if (checked) addIdsRespectingLimit(ids, group.items);
    else removeIds(ids);
  };

  const assignNow = async () => {
    let params = {
      agentId: agentId,
      FasTagIds: selectedRows
    }

    try {
      // Safety timeout so the UI never freezes if the request hangs.
      const response = await Promise.race([
        API.AssignAgent(JSON.stringify(params)),
        new Promise((_, reject) => setTimeout(() => reject(new Error('__timeout__')), 90000)),
      ]);

      if (response.status === 200 && response.success) {
        // If requestId is provided, also update the request status to Approved
        if (requestId) {
          try {
            const statusData = {
              requestId: requestId,
              requestStatus: "Approved"
            };
            const statusResponse = await API.UpdateAgentRequestStatus(JSON.stringify(statusData));
            if (statusResponse.status === 200 && statusResponse.success) {
              console.log('Request status updated to Approved');
            } else {
              console.warn('Failed to update request status:', statusResponse.message);
            }
          } catch (error) {
            console.error('Error updating request status:', error);
          }
        }

        // Handle success
        setShowConfirmModal(false);
        SuccessToast(response.message);
        dispatch({ type: "REFRESH_DATA" });
        setAssignCount(0);
        setSelectedRows([]);
        selectedItemsMap.current = {};
        getData();
        getData1();
        // ✅ Close modal and notify parent to refresh
        onClose();
      } else {
        // Handle error
        setShowConfirmModal(false);
        ErrorToast(response.message || 'Failed to assign FASTag.');
      }
    } catch (error) {
      console.error('Error assigning FASTag:', error);
      setShowConfirmModal(false);
      ErrorToast(error?.message === '__timeout__'
        ? 'The request is taking too long. Please try again.'
        : 'Failed to assign FASTag.');
    }
  };
  // Header "select all" for the available tab (selects every tag on the page, respecting the limit)
  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      addIdsRespectingLimit(currentPageItems.map((row) => row._id), currentPageItems);
    } else {
      removeIds(currentPageItems.map((row) => row._id));
    }
  };

  // Plain Tag Ref ID cell (flat list — no batch grouping / expand).
  const TagRefCell = ({ group }) => (
    <span className="font-medium text-gray-800 break-all">{group.sample?.tagRefId || 'N/A'}</span>
  );

  const VehicleClassCell = ({ group, idx }) => {
    const vehicleClassData = getVehicleClassData(group.sample?.vehicleClass);
    return (
      <div className="flex gap-2 items-center">
        <img src={vehicleClassData?.tagimage} alt="Tag" className="w-[34px]" />
        <p>{vehicleClassData?.value || group.sample?.vehicleClass}</p>
        <div className="pl-2 flex items-center cursor-pointer" onClick={() => toggleVisibility(idx, group.sample)}>
          {visibleRows[idx] ? <Eye className="h-5 w-5" /> : <EyeOff className="h-5 w-5" />}
        </div>
      </div>
    );
  };

  const tableColumns = [
    {
      label: (
        <CustomCheckbox checked={isAllSelected} onChange={handleSelectAllChange} />
      ),
      key: "select",
      tdClassName: "text-center",
      render: (group) => {
        const state = getBatchSelectionState(group);
        return (
          <CustomCheckbox
            checked={state === 'all'}
            indeterminate={state === 'some'}
            onChange={(e) => toggleBatchSelection(group, e.target.checked)}
          />
        );
      },
    },
    {
      label: "Tag Ref ID",
      key: "tagRefId",
      mobileMain: true,
      render: (group) => <TagRefCell group={group} />,
    },
    {
      label: "Batch Id",
      key: "batchId",
      render: (group) => <span className="text-gray-700 break-all">{group.sample?.batchId || 'N/A'}</span>,
    },
    {
      label: "Vehicle Class",
      key: "value",
      render: (group, idx) => <VehicleClassCell group={group} idx={idx} />,
    },
    { label: "Status", render: (group) => <StatusBadge status={group.sample?.agentStatus} /> },
    {
      label: "Purchase Date",
      render: (group) => moment(group.sample?.assignedDate).format("DD MMMM, YYYY, hh:mm A"),
      tdClassName: "text-end"
    },
  ];

  const tableColumns1 = [
    {
      label: "Tag Ref ID",
      key: "tagRefId",
      mobileMain: true,
      render: (group) => <TagRefCell group={group} />,
    },
    {
      label: "Batch Id",
      key: "batchId",
      render: (group) => <span className="text-gray-700 break-all">{group.sample?.batchId || 'N/A'}</span>,
    },
    {
      label: "Vehicle Class",
      key: "value",
      render: (group, idx) => <VehicleClassCell group={group} idx={idx} />,
    },
    { label: "Status", render: (group) => <StatusBadge status={group.sample?.agentStatus} /> },
    {
      label: "Assigned to", render: (group) => group.sample?.agentAssignedTo?.username || "N/A",
    },
    {
      label: "Delivery Date",
      render: (group) => moment(group.sample?.assignedDate).format("DD MMMM, YYYY, hh:mm A"),
      tdClassName: "text-end"
    },
  ];



  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 bg-white flex flex-col">
      <div className="bg-white w-full h-full overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b shrink-0">
          <div className="flex items-center gap-2">
            <button
              onClick={() => { setSelectedRows([]); selectedItemsMap.current = {}; onClose(); }}
              className="text-gray-600 hover:text-red-500 p-1"
              title="Back"
            >
              <ArrowLeft size={22} />
            </button>
            <div className="px-2 py-3 text-sm font-medium text-gray-800 ">
              <span className="font-semibold"> {title}</span>
            </div>
          </div>
          <button onClick={
            () => {
              setSelectedRows([]);
              selectedItemsMap.current = {};
              onClose();
            }
          }
            className="text-gray-500 hover:text-gray-700">
            <X size={22} />
          </button>
        </div>

        {/* Scrollable Content */}
        <div className="flex flex-col flex-1 overflow-hidden">
          {/* Summary */}


          {/* Tabs & Filters */}
          {showConfirmModal && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
              <div className="bg-white rounded-lg p-6 w-[400px] shadow-xl text-center">
                <p className="text-gray-800 text-lg font-medium mb-2">
                  You’re assigning {assignCount} FASTags to {agentName}.
                </p>
                <p className="text-sm font-bold text-gray-800 mb-6">Are you sure?</p>

                <div className="flex justify-center gap-4">
                  {/* Submit Button */}
                  <button
                    onClick={() => setShowConfirmModal(false)}
                    className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-6 py-2 rounded-full text-sm"
                  >
                    Cancel
                  </button>
                  {/* Cancel Button */}
                  <button
                    onClick={handleAssignNow}
                    className="bg-[#07AE4D] hover:bg-green-600 text-white px-6 py-2 rounded-full text-sm"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Table */}
          {activeTab === 'available' && (
            <CommonTable
              isPagination={true}
              hideDateAndDownload={true}
              paginationClass="!mt-0 !justify-between "
              columns={tableColumns}
              leftComponent={
                <div className="flex items-center space-x-2 ">
                  <button
                    onClick={() => setActiveTab('available')}
                    className={`${activeTab === 'available' ? 'bg-red-500 text-white' : 'bg-[#FEF5F5] text-[#1F1715]'
                      } text-[12px] font-medium px-4 py-2 rounded-full`}
                  >
                    Available FASTag
                  </button>
                  <button
                    onClick={() => setActiveTab('assignWithFile')}
                    className={`${activeTab === 'assignWithFile' ? 'bg-red-500 text-white' : 'bg-[#FEF5F5] text-[#1F1715]'
                      } text-[12px] font-medium px-4 py-2 rounded-full`}
                  >
                    Assign with file
                  </button>
                  <button
                    onClick={() => setActiveTab('assigned')}
                    className={`${activeTab === 'assigned' ? 'bg-red-500 text-white' : 'bg-[#FEF5F5] text-[#1F1715]'
                      } text-[12px] font-medium px-4 py-2 rounded-full`}
                  >
                    Assigned FASTag
                  </button>
                </div>
              }
              rightComponent={
                <div className="flex items-center gap-1.5">
                  {selectedRows.length > 0 && (
                    <div className="flex items-center gap-1.5">
                      {!isNaN(parseInt(maxQuantity, 10)) && parseInt(maxQuantity, 10) > 0 && (
                        <span className={`text-[12px] font-bold ${selectedRows.length === parseInt(maxQuantity, 10) ? 'text-[#07AE4D]' : 'text-gray-500 underline decoration-dotted'}`}>
                          Selected: {selectedRows.length} / {maxQuantity}
                        </span>
                      )}
                      <button
                        disabled={!isNaN(parseInt(maxQuantity, 10)) && parseInt(maxQuantity, 10) > 0 && selectedRows.length !== parseInt(maxQuantity, 10)}
                        className={`${(!isNaN(parseInt(maxQuantity, 10)) && parseInt(maxQuantity, 10) > 0 && selectedRows.length !== parseInt(maxQuantity, 10))
                          ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                          : 'bg-[#07AE4D] text-white hover:bg-green-600 cursor-pointer'
                          } text-[12px] px-4 py-2 rounded-full font-medium transition-colors`}
                        onClick={() => {
                          const uniqueSelectedIds = [...new Set(selectedRows)];
                          const limit = parseInt(maxQuantity, 10);
                          if (!isNaN(limit) && limit > 0 && uniqueSelectedIds.length !== limit) {
                            if (uniqueSelectedIds.length < limit) {
                              ErrorToast(`Incomplete selection. Please select exactly ${limit} FASTags. You currently have ${uniqueSelectedIds.length}.`);
                            } else {
                              ErrorToast(`Maximum limit exceeded. You selected ${uniqueSelectedIds.length} items, but can only assign ${limit}.`);
                            }
                            return;
                          }
                          if (reqVehicleClass) {
                            const invalidSelection = selectedRows.some(id =>
                              selectedItemsMap.current[id] && selectedItemsMap.current[id] !== reqVehicleClass
                            );
                            if (invalidSelection) {
                              const vehicleData = getVehicleClassData(reqVehicleClass);
                              ErrorToast(`Invalid vehicle class. Please select only ${vehicleData?.value || reqVehicleClass} tags.`);
                              return;
                            }
                          }

                          setAssignCount(selectedRows.length);
                          setShowConfirmModal(true);

                        }}
                      >
                        Assign Now
                      </button>
                    </div>
                  )}

                  <div className="flex items-center gap-1.5">
                    {showSearch && (
                      <div className="flex flex-wrap items-center gap-1 p-1 px-2 border border-gray-300 rounded-md focus-within:ring-1 focus-within:ring-red-500 w-[240px] bg-white min-h-[32px] max-h-[120px] overflow-y-auto relative">
                        {chips.map((chip, idx) => (
                          <div key={idx} className="flex items-center gap-1 bg-gray-100 text-gray-800 text-[10px] px-2 py-0.5 rounded-full border border-gray-200 shrink-0">
                            <span>{chip}</span>
                            <button
                              type="button"
                              onClick={() => removeChip(idx)}
                              className="text-gray-400 hover:text-red-500 focus:outline-none"
                            >
                              <X size={10} />
                            </button>
                          </div>
                        ))}
                        <input
                          type="text"
                          placeholder={chips.length === 0 ? "Search Serial / Batch" : ""}
                          value={inputValue}
                          onChange={handleInputChange}
                          onKeyDown={handleKeyDown}
                          onBlur={handleInputBlur}
                          className="flex-1 min-w-[80px] border-none outline-none focus:ring-0 p-0.5 text-[11px] text-gray-700 bg-transparent"
                        />
                        {chips.length === 0 && !inputValue && (
                          <Search className="text-gray-400 w-3.5 h-3.5 mr-1 select-none pointer-events-none shrink-0" />
                        )}
                      </div>
                    )}
                    <CustomSelectInput
                      name="value"
                      value={vcClass}
                      onChange={(e) => {
                        setVcClass(e.target.value);
                        setCurrentPage(1);
                      }}
                      options={vehicleClasses.map((item) => ({ ...item, name: item.value, value: item.value }))}
                      className="w-[130px] shrink-0"
                      inputClass="!mt-0 py-1 px-2 text-xs h-[32px]"
                      labelClass="hidden"
                    />
                  </div>
                </div>
              }
              data={paginatedAvailable}
              emptyMessage="No Inventory Found"
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              selectedDate={selectedDate}
              setCurrentPage={setCurrentPage}
              setItemsPerPage={setItemsPerPage}
              setSelectedDate={setSelectedDate}
              total={filteredAvailable.length}
              totalPages={Math.ceil(filteredAvailable.length / itemsPerPage)}
              extraTableClass="flex-1 overflow-y-auto [&_thead]:sticky [&_thead]:top-0 [&_thead]:z-10"
            />
          )}

          {activeTab === 'assignWithFile' && (
            <div className="flex flex-col h-full overflow-hidden">
              <div className="flex items-center m-2 shrink-0">
                <div className="flex items-center space-x-2 ">
                  <button
                    onClick={() => setActiveTab('available')}
                    className={`${activeTab === 'available' ? 'bg-red-500 text-white' : 'bg-[#FEF5F5] text-[#1F1715]'
                      } text-[12px] font-medium px-4 py-2 rounded-full`}
                  >
                    Available FASTag
                  </button>
                  <button
                    onClick={() => setActiveTab('assignWithFile')}
                    className={`${activeTab === 'assignWithFile' ? 'bg-red-500 text-white' : 'bg-[#FEF5F5] text-[#1F1715]'
                      } text-[12px] font-medium px-4 py-2 rounded-full`}
                  >
                    Assign with file
                  </button>
                  <button
                    onClick={() => setActiveTab('assigned')}
                    className={`${activeTab === 'assigned' ? 'bg-red-500 text-white' : 'bg-[#FEF5F5] text-[#1F1715]'
                      } text-[12px] font-medium px-4 py-2 rounded-full`}
                  >
                    Assigned FASTag
                  </button>
                </div>
              </div>
              <div className="flex-1 overflow-y-auto">
                <div className="flex flex-col md:flex-row justify-center gap-8 px-6 py-[51px] border-t">
                  {/* Upload Box */}
                  <div className="flex flex-col items-center space-y-4 w-full md:w-auto">
                    <div
                      onClick={!isUploading ? handleBoxClick : undefined}
                      className={`border-2 ${selectedFile ? 'border-blue-500' : 'border-green-500'} flex justify-center items-center gap-[18px] rounded-lg p-6 text-center ${selectedFile ? 'text-blue-700' : 'text-green-700'} ${!isUploading ? 'cursor-pointer' : 'cursor-not-allowed opacity-50'} text-sm w-full md:w-[306px]`}
                    >
                      {selectedFile ? (
                        <div className="flex flex-col items-center">
                          <span className="font-medium mb-1">Selected File:</span>
                          <span className="text-xs text-gray-600 break-all">{selectedFile.name}</span>
                          <span className="text-xs text-gray-500">({(selectedFile.size / 1024).toFixed(2)} KB)</span>
                        </div>
                      ) : (
                        <>
                          Select / Drop File here
                          <span className="ml-2 text-lg">
                            <img src={uploading} className="w-[18px]" alt="Upload Icon" />
                          </span>
                        </>
                      )}
                    </div>

                    {/* Upload Button */}
                    {selectedFile && (
                      <div className="flex gap-2">
                        <button
                          onClick={handleFileUpload}
                          disabled={isUploading}
                          className={`px-6 py-2 rounded-full text-sm font-medium ${isUploading
                            ? 'bg-gray-400 cursor-not-allowed'
                            : 'bg-[#07AE4D] hover:bg-green-600'
                            } text-white`}
                        >
                          {isUploading ? 'Uploading...' : 'Upload & Assign'}
                        </button>
                        <button
                          onClick={() => {
                            setSelectedFile(null);
                            fileInputRef.current.value = '';
                          }}
                          disabled={isUploading}
                          className="px-4 py-2 rounded-full text-sm font-medium bg-gray-300 hover:bg-gray-400 text-gray-700"
                        >
                          Clear
                        </button>
                      </div>
                    )}

                    {/* Loading indicator */}
                    {isUploading && (
                      <div className="flex items-center gap-2 text-sm text-gray-600">
                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-600"></div>
                        Processing file...
                      </div>
                    )}
                  </div>

                  {/* Hidden File Input */}
                  <input
                    type="file"
                    ref={fileInputRef}
                    className="hidden"
                    onChange={handleFileChange}
                    accept=".xlsx,.xls"
                  />

                  {/* Vertical Divider */}
                  <div className="hidden md:block w-px bg-[#9C9B9B]" />

                  {/* Download Instructions */}
                  <div className="text-sm text-gray-700 flex flex-col justify-center">
                    <a
                      href="#"
                      onClick={handleDownloadSample}
                      className="text-blue-600 font-medium flex items-center gap-1 mb-2 cursor-pointer"
                    >
                      <span><img src={download} className="w-[13px]" alt="Download Icon" /></span> Download sample file
                    </a>
                    <ul className="list-disc pl-4 space-y-1 text-gray-600">
                      <li>Download sample file</li>
                      <li>Fill all required columns</li>
                      <li>Upload and check file status</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
          {activeTab === 'assigned' && (
            <CommonTable
              isPagination={true}
              hideDateAndDownload={true}
              paginationClass="!mt-0 !justify-between "
              columns={tableColumns1}
              leftComponent={
                <div className="flex items-center space-x-2 ">
                  <button
                    onClick={() => setActiveTab('available')}
                    className={`${activeTab === 'available' ? 'bg-red-500 text-white' : 'bg-[#FEF5F5] text-[#1F1715]'
                      } text-[12px] font-medium px-4 py-2 rounded-full`}
                  >
                    Available FASTag
                  </button>
                  <button
                    onClick={() => setActiveTab('assignWithFile')}
                    className={`${activeTab === 'assignWithFile' ? 'bg-red-500 text-white' : 'bg-[#FEF5F5] text-[#1F1715]'
                      } text-[12px] font-medium px-4 py-2 rounded-full`}
                  >
                    Assign with file
                  </button>
                  <button
                    onClick={() => setActiveTab('assigned')}
                    className={`${activeTab === 'assigned' ? 'bg-red-500 text-white' : 'bg-[#FEF5F5] text-[#1F1715]'
                      } text-[12px] font-medium px-4 py-2 rounded-full`}
                  >
                    Assigned FASTag
                  </button>
                </div>
              }
              data={paginatedAssigned}
              emptyMessage="No Inventory Found"
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              selectedDate={selectedDate}
              setCurrentPage={setCurrentPage}
              setItemsPerPage={setItemsPerPage}
              setSelectedDate={setSelectedDate}
              total={groupedAssigned.length}
              totalPages={Math.ceil(groupedAssigned.length / itemsPerPage)}
              extraTableClass="flex-1 overflow-y-auto [&_thead]:sticky [&_thead]:top-0 [&_thead]:z-10"
            />
          )}
        </div>
      </div>

      {modalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
          <div className="relative bg-white rounded-[20px] shadow-lg w-full max-w-xl p-6">
            <div className="absolute top-4 right-4 gap-3 flex-row flex">
              <button
                onClick={() => {
                  setModalOpen(false);
                  if (selectedIndex !== null) {
                    toggleVisibility(selectedIndex, selectedClass);
                  }
                }}
                className="text-gray-600 hover:text-red-500"
              >
                <X size={20} />
              </button>
            </div>
            <h2 className="text-xl font-semibold mb-[4px] text-center">
              {vehicleData?.value}
            </h2>
            <p className="mb-[30px] text-sm text-center">
              {vehicleData?.description}
            </p>
            <div className="relative w-full flex justify-center items-center py-8 px-4">
              <div className="relative bg-white p-8 rounded-2xl shadow-2xl border border-gray-200 max-w-2xl w-full">
                {/* Decorative corner accents */}
                <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-red-500 rounded-tl-2xl opacity-20"></div>
                <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-red-500 rounded-br-2xl opacity-20"></div>

                {/* Image container with classic frame */}
                <div className="relative bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-xl border-2 border-gray-300 shadow-inner">
                  <img
                    src={vehicleData?.cardWebp}
                    alt={vehicleData?.name}
                    className="w-full h-auto object-contain rounded-lg transition-transform duration-500 hover:scale-[1.12]"
                  />
                </div>

                {/* Elegant bottom accent */}
                <div className="mt-6 flex justify-center">
                  <div className="h-1 w-24 bg-gradient-to-r from-transparent via-red-500 to-transparent rounded-full"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default CommonTableModal;